module.exports = __webpack_public_path__ + "img/7_45.d7ca3551.png";